import React from "react";

import "./BetControls.css";
import { Value } from "./core/Value";
import { Controller } from "./core/Controller";
import { Comm } from "./core/comm/Comm";
import BetControl from "./BetControl";

class BetControls extends React.Component<BetControls.Props, BetControls.State>
{

    constructor(props: BetControls.Props)
    {
        super(props);

        this.state = {
            views: []
        };
    }


    componentDidMount()
    {
        Comm.on(Comm.RESPONSE.INITIALIZE, this.onInitialize, this);
        
        this.addView();
        this.addView();
    }


    componentWillUnmount()
    {
        Comm.off(Comm.RESPONSE.INITIALIZE, this.onInitialize, this);
    }


    async onInitialize(data: Comm.ResponseTypes.Init, init: boolean, serviceRestarted: boolean)
    {
        if (Controller.active_bets.length < this.state.views.length)
        {
            await new Promise((resolve) => {
                while (this.state.views.length < Controller.active_bets.length)
                {
                    this.state.views.push({
                        id: null,
                        betState: "bet",
                        lastBetClicked: null,
                        betStatePending: false,
                        menuIdx: 0,
                        autoBet: false,
                        autoCashout: false
                    });
                }

                this.setState({
                    views: this.state.views
                }, () => resolve(null));
            })
        }

        for (let idx = 0; idx < Math.max(Controller.active_bets.length, this.state.views.length); idx++)
        {
            const bet = Controller.active_bets[idx];
            
            if (bet && !Number(bet.multiplier))
            {
                Value.getNumber(Value.ID.BET + "_" + idx).value = bet.bet_amount;

                const autoCashout = !!bet.cashout_at;

                if (autoCashout)
                {
                    Value.getNumber(Value.ID.CASHOUT + "_" + idx).value = bet.cashout_at;
                    Value.getNumber("cashout_btn_" + idx).value = bet.cashout_at;
                }

                this.state.views[idx].autoCashout = autoCashout;
                this.state.views[idx].id = bet.bet_id;
                this.state.views[idx].menuIdx = autoCashout ? 1 : 0;

                if (Controller.state == "starting")
                {
                    this.state.views[idx].betState = "cancel";
                }
                else if (Controller.state == "in_progress")
                {
                    this.state.views[idx].betState = "cashout";
                }
                
                this.state.views[idx].betStatePending = false;
            }
            else if (!serviceRestarted)
            {
                this.state.views[idx].betState = "bet";
                this.state.views[idx].betStatePending = false;
                this.state.views[idx].autoBet = false;
                this.state.views[idx].id = null;
                this.state.views[idx].uuid = null;
            }
        }

        this.setState({
            views: this.state.views
        });
    }


    render()
    {
        return (
            <div
                id="bet_controls"
            >
                {this.renderControls()}
            </div>
        );
    }


    renderControls()
    {
        const arr = [] as Array<JSX.Element>;

        this.state.views.forEach((view, index, views) =>
        {
            arr.push(
                <BetControl
                    key={index}
                    index={index}
                    view={view}
                    onViewUpdate={(view) => this.setState({
                        views: this.state.views.map((v, i) => i == index ? view : v)
                    })}
                    {...(index == views.length - 1 ? (
                        views.length == 1 ? ({
                            onAdd: this.addView.bind(this)
                        }) : ({
                            onRemove: this.removeView.bind(this)
                        })
                    ) : {})}
                />
            );
        });

        return arr;
    }


    removeView()
    {
        this.state.views.pop();
        this.setState({
            views: this.state.views
        });
    }


    addView()
    {
        this.state.views.push({
            id: null,
            betState: "bet",
            lastBetClicked: null,
            betStatePending: false,
            menuIdx: 0,
            autoBet: false,
            autoCashout: false
        });

        this.setState({
            views: this.state.views
        });
    }


}

namespace BetControls
{
    export interface Props
    {

    }

    export interface State
    {
        views: Array<BetView>;
    }

    export interface BetView
    {
        uuid?: string;
        id?: number;
        betState: "bet" | "waiting" | "cancel" | "cashout";
        betStatePending: boolean;
        lastBetClicked: number;
        menuIdx: number;
        autoBet: boolean;
        autoCashout: boolean;
    }
}

export default BetControls;